module.exports = "/static/assets/49b93348956d521f4b31aedb047b1cc1.png";